import type { NextPageContext } from 'next';

import { COOKIE_NAME } from 'helpers/optimize/constants';
import {
  getCurrentExperiment,
  isExperimentRunning,
  getWeights,
  isControl,
  getVariant,
  getMaxAge,
} from 'helpers/optimize/optimize';
import { getServerCookie } from 'utils/CookieUtils';

/**
 * If an experiment is configured and active, this function will set an A/B cookie that includes a variantId, where the variant and weighting is controlled by the configured experiment.
 * @param context NextPage context
 * @returns the A/B cookie set
 */
export const ab = (
  context: NextPageContext,
  callback: (err: Error) => void,
): { cookie: string | null; cookieToSet: string } | null => {
  let cookieToSet: string = '';
  const experiment = getCurrentExperiment();
  let cookie = getServerCookie(COOKIE_NAME, context, true);
  if (!cookie && !isExperimentRunning()) {
    return null;
  }
  if (cookie && !isExperimentRunning()) {
    cookieToSet = `${COOKIE_NAME}=; max-age=0; path=/;`;
    return null;
  }
  if (!cookie && isExperimentRunning()) {
    if (!experiment) callback(new Error('Error getting experiment'));
    const weights = getWeights();
    if (weights) {
      let random = Math.random() * 100;
      let variant: string = '';
      weights.find((weight, index) => {
        if (weight >= random) {
          variant = (index + 1).toString();
          return true;
        }
        random -= weight;
      });
      if (!variant) {
        callback(new Error('error calculating variant'));
      } else {
        cookie = variant.toString(); // either 1 (legacy auth) or 2 (keycloak auth)
      }
    }
  }
  if (
    !getServerCookie(COOKIE_NAME, context, true) &&
    isExperimentRunning() &&
    cookie !== undefined
  ) {
    cookieToSet = `${COOKIE_NAME}=${cookie}; max-age=${getMaxAge(
      cookie,
    )}; path=/;`;
  }
  return { cookie: cookie || null, cookieToSet };
};

export { isControl, getVariant };
